import deepmerge from "deepmerge";
import axios from "axios";

const designerAvailabilityPath = (calendar, availability) => {
  const idPart = availability && availability.id ? `/${availability.id}` : '';
  return `/design/calendars/${calendar.id}/availabilities${idPart}`;
};
export const createAvailability = (calendar, availability, onSuccess, onError) => {
  const data = { availability: { ...availability} };
  axios
    .post(designerAvailabilityPath(calendar, availability), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};
export const updateAvailability = (availability, onSuccess, onError) => {
  const data = { availability: { ...availability } };
  axios
    .put(designerAvailabilityPath({ id: availability.calendar_id }, availability), data)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};

export const deleteAvailability = (availability, onSuccess, onError) => {
  axios
    .delete(designerAvailabilityPath({ id: availability.calendar_id }, availability))
    .then(response => {
      onSuccess(response.data);
    })
    .catch(onError);
};



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/api/CalendarApi.js